<template>
	<div>
    <v-container grid-list-xl>
        <v-layout row wrap>
          <v-tabs slider-color="grey">
            <v-tab class="tab" :key="1" ripple>Regional Reps</v-tab>
            <v-tab class="tab" :key="2" ripple>Responsible Reps</v-tab>
            <v-tab-item class="pl-4 pr-4 pt-0 pb-4" :key="1">
                <v-layout row wrap>
                  <v-flex xs3>
                    <v-text-field append-icon="search" label="Search" v-if="availableReps != ''" solo single-line v-model="search"></v-text-field><br />
                  </v-flex>
                  <v-data-table loading="true" :headers="headers" v-if="availableReps != ''" :items="availableReps" :rows-per-page-items="[20,40,60,80,100]" :search="search" hide-actions disable-initial-sort class="elevation-1">
                    <template slot="items" slot-scope="props">
                      <td width="10%"><v-switch v-model="props.item.selected" @click="fncSaveUser(props.item.id, props.item.selected)"></v-switch></td>
                      <td width="90%">{{ props.item.fullname }}</td>
                    </template>
                  </v-data-table>
                  <v-flex xs12 v-else>
                    <strong>&nbsp;No regional users could be found</strong>
                  </v-flex>
                </v-layout>
            </v-tab-item>
            <v-tab-item class="pl-4 pr-4 pt-4 pb-4" :key="2">
              <v-container grid-list-xl>
                <v-layout row wrap>
                  <v-data-table loading="true" :headers="headers" v-if="explodedRepUsers != ''" :items="explodedRepUsers" :rows-per-page-items="[20,40,60,80,100]" :search="search" hide-actions disable-initial-sort class="elevation-1">
                    <template slot="items" slot-scope="props">
                      <td width="10%"><v-switch v-model="props.item.selected" @click="fncSaveResponseUser(props.item.id, globalModalParams.quoteId.id, props.item.selected)"></v-switch></td>
                      <td width="90%">{{ props.item.fullname }}</td>
                    </template>
                  </v-data-table>
                  <v-flex xs12 v-else>
                    <strong>&nbsp;No rep users could be found</strong>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-tab-item>
          </v-tabs>
          <div class="pl-4 pr-1 pb-4 buttonHolder">
            <div class="pl-4 pr-1 pb-2 pt-4 buttonHolder">
              <div style="float: right">
                <v-btn class="text-xs-right cancelButton" @click.stop="fncHideModal">Close</v-btn>
              </div>
            </div>
          </div>
        </v-layout>
    </v-container>
      <!--<v-container grid-list-xl>
        <v-flex xs3>
          <v-text-field append-icon="search" label="Search" v-if="availableReps != ''" solo single-line v-model="search"></v-text-field><br />
        </v-flex>
        <v-data-table loading="true" :headers="headers" v-if="availableReps != ''" :items="availableReps" :rows-per-page-items="[20,40,60,80,100]" :search="search" hide-actions disable-initial-sort class="elevation-1">
          <template slot="items" slot-scope="props">
              <td width="10%"><v-switch v-model="props.item.selected" @click="fncSaveUser(props.item.id, props.item.selected)"></v-switch></td>
              <td width="90%">{{ props.item.fullname }}</td>
          </template>
        </v-data-table>
        <p v-else>No users could be found</p>
        <v-layout row wrap class="pl-4 pr-4 pt-4 pb-4">
          <div class="pl-4 pr-1 pb-2 pt-4 buttonHolder">
            <div style="float: right">
              <v-btn class="text-xs-right cancelButton" @click.stop="fncHideModal">Close</v-btn>
            </div>
          </div>
        </v-layout>
      </v-container>-->
      </div>
</template>

<script>

	import { mapGetters } from 'vuex';

	export default {
        name: 'UserNotifications',
        components: {},
		data () {
          return {
              search: '',
              explodedRepUsers: [],
              // linkTypeSingle: this.$store.getters.globalModalParams.userType,
              linkTypeSingle: '',
              linkType: [
                { id: 1, text: 'Manufacturer Users' },
                { id: 2, text: 'Customer Users' },
                { id: 3, text: 'Specifier Users' },
                { id: 4, text: 'Public Users' }
              ],
              currentUserCompany: this.$store.getters.currentUserCompany,
              headers: [
                { text: 'Override', value: '', width: '10%' },
                { text: 'Name', value: 'fullname', width: '90%' }
              ]
			}
		},
		methods: {
      fncCheckQuoteLink( userId ) {
        if( this.quoteUsers.indexOf( userId ) != -1 ) {
          console.log( 'TRUE' );
          return true;
        } else {
          console.log( 'FALSE' );
          return false;
        }
      },
          fncHideModal() {
                this.$store.commit('fncEmptyQuoteList');
                this.$store.dispatch({
                  type: 'fncPopulateQuoteList',
                  refresh: true
                })
                this.$store.commit('hideModal');
            },
            fncFetchUsers() {
              this.$store.dispatch({
                type: 'fncFetchLinkUsers',
                userType: this.linkTypeSingle,
                userId: this.globalModalParams.userId,
                linkType: this.globalModalParams.userType
              })
            },
            fncSaveUser(userId, linked) {
              var selected = false;
              if ( linked == false ) {
                selected = true;
              }
              this.$store.dispatch({
                type: 'fncQuoteLinkUser',
                link: selected,
                parent: userId,
                child: this.globalModalParams.quoteId.customer_id
              });
            },
            fncSaveResponseUser(userId, quoteId, linked) {
              if( linked == true ) {
                linked = false;
              } else {
                linked = true;
              }
              this.$store.dispatch({
                type: 'fncQuoteLinkUserSingle',
                link: linked,
                user: userId,
                quote: quoteId
              });
            }
		},
		computed: {
			...mapGetters([
        'objAuthorize',
        'globalModalParams',
        'availableReps',
        'repUsers',
        'quoteUsers'
			])
        },
    beforeMount() {
      this.$store.dispatch({
        type: 'fncPopulateQuoteUsers',
        quote: this.globalModalParams.quoteId.id
      });
      this.$store.dispatch({
        type: 'fncPopulateUsers',
        context: 1
      });
    },
    watch: {
          repUsers() {
            this.explodedRepUsers = [];
            for( var a in this.repUsers ) {
              if( this.quoteUsers.indexOf(this.repUsers[a].id) != -1 ) {
                this.explodedRepUsers.push({id: this.repUsers[a].id, fullname: this.repUsers[a].label, selected: true});
              } else {
                this.explodedRepUsers.push({id: this.repUsers[a].id, fullname: this.repUsers[a].label, selected: false});
              }
              if( this.repUsers[a].branch.length > 0 ) {
                for( var b in this.repUsers[a].branch ) {
                  if( this.quoteUsers.indexOf(this.repUsers[a].branch[b].id) != -1 ) {
                    this.explodedRepUsers.push({id: this.repUsers[a].branch[b].id, fullname: this.repUsers[a].branch[b].label, selected: true});
                  } else {
                    this.explodedRepUsers.push({id: this.repUsers[a].branch[b].id, fullname: this.repUsers[a].branch[b].label, selected: false});
                  }
                  if( this.repUsers[a].branch[b].branch.length > 0 ) {
                    for( var c in this.repUsers[a].branch[b].branch ) {
                      if( this.quoteUsers.indexOf(this.repUsers[a].branch[b].branch[c].id) != -1 ) {
                        this.explodedRepUsers.push({id: this.repUsers[a].branch[b].branch[c].id, fullname: this.repUsers[a].branch[b].branch[c].label, selected: true});
                      } else {
                        this.explodedRepUsers.push({id: this.repUsers[a].branch[b].branch[c].id, fullname: this.repUsers[a].branch[b].branch[c].label, selected: false});
                      }
                      if( this.repUsers[a].branch[b].branch[c].branches.length > 0 ) {
                        for( var d in this.repUsers[a].branch[b].branch[c].branch ) {
                          if( this.quoteUsers.indexOf(this.repUsers[a].branch[b].branch[c].branches[d].id) != -1 ) {
                            this.explodedRepUsers.push({ id: this.repUsers[a].branch[b].branch[c].branches[d].id, label: this.repUsers[a].branch[b].branch[c].branch[d].label, selected: true });
                          } else {
                            this.explodedRepUsers.push({ id: this.repUsers[a].branch[b].branch[c].branches[d].id, label: this.repUsers[a].branch[b].branch[c].branch[d].label, selected: false });
                          }
                          if( this.repUsers[a].branch[b].branch[c].branch[d].branch.length > 0 ) {
                            for( var e in this.repUsers[a].branch[b].branch[c].branch[d].branch ) {
                              if( this.quoteUsers.indexOf(this.repUsers[a].branch[b].branch[c].branch[d].branch[e].id) != -1 ) {
                                this.explodedRepUsers.push({ id: this.repUsers[a].branch[b].branch[c].branch[d].branch[e].id, fullname: this.repUsers[a].branch[b].branch[c].branch[d].branch[e].label, selected: true });
                              } else {
                                this.explodedRepUsers.push({ id: this.repUsers[a].branch[b].branch[c].branch[d].branch[e].id, fullname: this.repUsers[a].branch[b].branch[c].branch[d].branch[e].label, selected: false });
                              }
                              if( this.repUsers[a].branch[b].branch[c].branch[d].branch[e].branch.length > 0 ) {
                                for( var f in this.repUsers[a].branch[b].branch[c].branch[d].branch[e].branch ) {
                                  if( this.quoteUsers.indexOf(this.repUsers[a].branch[b].branch[c].branch[d].branch[e].branch[f].id) != -1 ) {
                                    this.explodedRepUsers.push({ id: this.repUsers[a].branch[b].branch[c].branch[d].branch[e].branch[f].id, fullname: this.repUsers[a].branch[b].branch[c].branch[d].branch[e].branch[f].label, selected: true });
                                  } else {
                                    this.explodedRepUsers.push({ id: this.repUsers[a].branch[b].branch[c].branch[d].branch[e].branch[f].id, fullname: this.repUsers[a].branch[b].branch[c].branch[d].branch[e].branch[f].label, selected: false });
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
    }
	}
</script>

<style scoped>
	@import '../../shared/assets/css/shared.css';
</style>
